$(document).ready(function () {
  setupEnableSteps();

  $(".complex-datetime .input-group-addon").on("click", (_) => {
    $(".complex-datetime .datepicker").focus();
  });

  const prolongSelector = $("#date_end_time_prolong");
  if (prolongSelector) {
    const date = new Date();
    date.setHours(date.getHours() + 1);

    $("#date_end_time_prolong").val(date.getHours()).trigger("change");
    parseComplexDateTime(
      "#ProlongDeadlineForm_date_end",
      "#ProlongDeadlineForm_date_end_visible",
      "#date_end_time_prolong"
    );
  }

  $('a[data-toggle="tab"]').on("show.bs.tab", (e) => {
    const $target = $(e.target);
    if ($target.parent().hasClass("disabled")) {
      return false;
    } else {
      $(".sr-task-edit-content.wizard li.active").removeClass("active");
    }
  });

  validationStepWatcher(
      [
        {
          validator: Validator.required,
          event: "change",
          selector: "#ProjectsTasks_worker_id",
          errorSelector: "#ProjectsTasks_worker_id-error",
          errorMessage: translate.taskErrors.workerRequired,
        },
        {
          validator: Validator.required,
          event: "change",
          selector: "#ProjectsTasks_date_end",
          errorSelector: "#ProjectsTasks_date_end-error",
          errorMessage: translate.taskErrors.dateEndRequired,
        },
      ],
      "#tab1 .next-step .btn",
      "#tab1",
      () => {
        trackEventOnStepChange(1);
        backendValidation("#edit-task-form", [
          "worker_id",
          "editGroup",
          "date_end",
        ], 1)
      }
  );

  validationStepWatcher(
    [
      {
        validator: Validator.required,
        event: "change",
        selector: "#ProjectsTasks_category",
        errorSelector: "#ProjectsTasks_category-error",
        errorMessage: translate.taskErrors.categoryRequired,
      },
      {
        validator: Validator.required,
        event: "change",
        selector: "#ProjectsTasks_categories_task_id",
        errorSelector: "#ProjectsTasks_categories_task_id-error",
        errorMessage: translate.taskErrors.subCategoryRequired,
      },
      {
        validator: Validator.requiredOneOf,
        event: "change",
        selector:
          ".subCategory_attributes .attribute input:not([type=hidden]), .subCategory_attributes .attribute select",
        errorSelector: "#ProjectsTasks_category_attributes-error",
        errorMessage: translate.taskErrors.attributeRequired,
      },
    ],
    "#tab2 .next-step .btn",
    "#tab2",
    () => {
      trackEventOnStepChange(2);
      backendValidation('#edit-task-form', [
        'category',
        'categories_task_id',
        'category_attributes'
      ], 2);
    }
  );

  validationStepWatcher(
    [
      {
        validator: Validator.required,
        event: "blur",
        selector: "#ProjectsTasks_title",
        errorSelector: "#ProjectsTasks_title-error",
        errorMessage: translate.taskErrors.titleRequired,
      },
      {
        validator: Validator.maxLength,
        event: "keyup",
        selector: "#ProjectsTasks_title",
        errorSelector: "#ProjectsTasks_title-error",
        errorMessage: translate.taskErrors.titleMaxLength,
        restriction: 300,
      },
      {
        validator: Validator.maxLength,
        event: "keyup",
        selector: "#ProjectsTasks_description",
        errorSelector: "#ProjectsTasks_description-error",
        errorMessage: translate.taskErrors.descriptionMaxLength,
        restriction: 10000,
      },
    ],
    "#tab3 .next-step .btn",
    "#tab3",
    () => {
      trackEventOnStepChange(3);
      backendValidation('#edit-task-form', ['title', 'description'], 3);
    }
  );
  validationStepWatcher(
    [
      {
        validator: Validator.required,
        event: "blur",
        selector: "#ProjectsTasks_price",
        errorSelector: "#ProjectsTasks_price-error",
        errorMessage: translate.taskErrors.priceRequired,
      },
      {
        validator: Validator.minValue,
        event: "keyup",
        selector: "#ProjectsTasks_price",
        errorSelector: "#ProjectsTasks_price-error",
        errorMessage: translate.taskErrors.priceMinValue,
        restriction: 1,
      },
    ],
    "#endTab .last-step .btn",
    "#endTab",
    () => {
      trackEventOnStepChange(4);
      backendValidation('#edit-task-form', ['price'], 4, () =>
        $('#edit-task-form').submit(), true
      );
    }
  );

  $(".previous-step .btn").click((e) => {
    const $active = $(".wizard .nav li.active");
    prevTab($active);
  });

  encodeComplexDateTime(
    "#ProjectsTasks_date_end",
    "#ProjectsTasks_date_end_visible",
    "#date_end_time"
  );
  $("#date_end_time, #ProjectsTasks_date_end_visible").change((_) =>
    parseComplexDateTime(
      "#ProjectsTasks_date_end",
      "#ProjectsTasks_date_end_visible",
      "#date_end_time"
    )
  );
  $("#date_end_time_prolong, #ProlongDeadlineForm_date_end_visible").change(
    (_) =>
      parseComplexDateTime(
        "#ProlongDeadlineForm_date_end",
        "#ProlongDeadlineForm_date_end_visible",
        "#date_end_time_prolong"
      )
  );
});

const encodeComplexDateTime = (
  dateTimeSelector,
  dateVisibleSelector,
  dateTimeVisibleSelector
) => {
  let dateTime = $(dateTimeSelector).val();
  if (!!dateTime) {
    dateTime = dateTime.replace(" ", "T") + "Z";
    const resUTCDate = new Date(dateTime);
    $(dateVisibleSelector).val(
      `${addFirstZero(resUTCDate.getDate())}.${addFirstZero(
        resUTCDate.getMonth() + 1
      )}.${addFirstZero(resUTCDate.getFullYear())}`
    );
    $(dateTimeVisibleSelector).val(resUTCDate.getHours().toString());
    $(dateTimeVisibleSelector).trigger("change");
  } else {
    $(dateTimeVisibleSelector).val("18");
    $(dateTimeVisibleSelector).trigger("change");
  }
};

const parseComplexDateTime = (
  dateTimeSelector,
  dateVisibleSelector,
  dateTimeVisibleSelector
) => {
  const time = $(dateTimeVisibleSelector).val();
  const dateEnd = $(dateVisibleSelector).val();
  if ((!!time || time === 0) && !!dateEnd) {
    const dateArray = dateEnd.split(".").map((x) => Number(x));
    const date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
    date.setHours(time);
    $(dateTimeSelector).val(formatDateTimeWithOffset(date));
  }
};

const formatDateTimeWithOffset = (date) => {
  const resLocalDate = new Date(date);
  return `${resLocalDate.getUTCFullYear()}-${addFirstZero(
    resLocalDate.getUTCMonth() + 1
  )}-${addFirstZero(resLocalDate.getUTCDate())} ${addFirstZero(
    resLocalDate.getUTCHours()
  )}:${addFirstZero(resLocalDate.getUTCMinutes())}:${addFirstZero(
    resLocalDate.getUTCSeconds()
  )}`;
};

const addFirstZero = (num) => (num < 10 ? `0${num}` : num);

const validationStepWatcher = (
  validations,
  buttonSelector,
  tabHref,
  callback
) => {
  // {validator, event, selector, errorSelector, errorMessage, restriction}
  validations.forEach((item) => {
    $(item.selector).on(item.event, (_) => {
      item.validator(
        item.selector,
        item.errorSelector,
        item.errorMessage,
        item.restriction
      );
    });
  });
  $(buttonSelector).click((event) => {
    goNextEvent(event, validations, callback);
  });
  $(document).keydown((event) => {
    const $active = $(".wizard .nav li.active");
    if (
      $active.has($(`a[href='${tabHref}'`)).length &&
      event.key === "Enter" &&
      !$(".simditor-wrapper")[0].contains(event.target)
    ) {
      goNextEvent(event, validations, callback);
    }
  });
};

const Validator = {
  required: (selector, errorSelector, errorMessage) => {
    if (!$(selector).val()) {
      setErrorText(errorSelector, errorMessage);
      return (error = {}) => getErrorObject(selector, "required", error);
    }
    removeErrorText(errorSelector, errorMessage);
    return null;
  },
  requiredOneOf: (arraySelector, errorSelector, errorMessage) => {
    if (
      $(arraySelector).toArray().length > 0 &&
      $(arraySelector)
        .toArray()
        .every((element) => Validator.required($(element), null, null) !== null)
    ) {
      setErrorText(errorSelector, errorMessage);
      return (error = {}) =>
        getErrorObject(arraySelector, "requiredOneOf", error);
    }
    removeErrorText(errorSelector, errorMessage);
    return null;
  },
  minValue: (selector, errorSelector, errorMessage, minValue) => {
    if ($(selector).val() < minValue) {
      setErrorText(errorSelector, errorMessage);
      return (error = {}) => getErrorObject(selector, "minValue", error);
    }
    removeErrorText(errorSelector, errorMessage);
    return null;
  },
  maxLength: (selector, errorSelector, errorMessage, maxLength) => {
    if ($(selector).val() && $(selector).val().length > maxLength) {
      setErrorText(errorSelector, errorMessage);
      return (error = {}) => getErrorObject(selector, "maxLength", error);
    }
    removeErrorText(errorSelector, errorMessage);
    return null;
  },
};

const setErrorText = (errorSelector, errorMessage = "") => {
  if (errorSelector) {
    $(errorSelector).text(errorMessage);
  }
};

const removeErrorText = (errorSelector, errorMessage = "") => {
  if (errorSelector && $(errorSelector).text() === errorMessage) {
    $(errorSelector).text("");
  }
};

const getErrorObject = (selector, errorType, error = {}) => {
  error[selector] = errorType;
  return error;
};

const nextTab = () => {
  const $active = $(".wizard .nav li.active");
  $active.removeClass("active");
  $active.next().removeClass("disabled");
  $($active).next().find('a[data-toggle="tab"]').click();
};

const prevTab = (elem) => {
  $(elem).prev().find('a[data-toggle="tab"]').click();
};


const onNextStepClickDataLaterPush = (stepNum, errorText = '') => {
  const userIdEl = document.getElementById('userId');
  const userId = userIdEl ? userIdEl.content : '0';
  try {
    if (typeof window.ym === 'function') {
      window.ym(29709265, 'reachGoal', 'tasks_task_creation_continue', {
        step_status: !!errorText ? 'Cancel' : 'OK',
        step_num: stepNum,
        error: errorText || 'Nothing',
        user_id: userId
      });
    }
  } catch (_) {}
};

const onCreateClickDataLaterPush = (sum, hasCompensation) => {
  const userIdEl = document.getElementById('userId');
  const userId = userIdEl ? userIdEl.content : '0';
  try {
    if (typeof window.ym === 'function') {
      window.ym(29709265, 'reachGoal', 'tasks_task_creation', {
        sum: sum,
        compensation: hasCompensation ? 'yes' : 'no',
        user_id: userId
      });
    }
  } catch (_) {}
};

const trackEventOnStepChange = (step) => {
  switch (step) {
    case 1:
      window.parent.postMessage({ type: 'customerTaskEvent', payload: { eventName: 'сlient_cabtasks_workerdeadline_continue_click' } });
      break;
    case 2:
      window.parent.postMessage({ type: 'customerTaskEvent', payload: { eventName: 'сlient_cabtasks_tasktype_continue_click' } });
      break;
    case 3:
      window.parent.postMessage({ type: 'customerTaskEvent', payload: { eventName: 'сlient_cabtasks_taskdesc_continue_click' } });
      break;
    case 4:
      window.parent.postMessage({ type: 'customerTaskEvent', payload: { eventName: 'сlient_cabtasks_price_create_click' } });
      break;
  }
}

const backendValidation = (formSelector, fields, step, callback, isLastStep = false) => {
  const $form = $(formSelector);

  const fieldsObj = fields.reduce((obj, field, index) => {
    obj[`validateAttributes[${index}]`] = field;
    return obj;
  }, {});

  let data = $form.serialize() + "&" + $.param(fieldsObj);

  $.ajax({
    url: $form.attr("action"),
    method: "POST",
    data,
    beforeSend: () => {
      $form.find('button').attr({ disabled: true });
    },
    success: (response) => {
      $form.find('button').attr({ disabled: isLastStep });
      if (response) {
        response = JSON.parse(response);
        if (response.code === 0) {
          fields.forEach((item) => {
            setErrorText(`#ProjectsTasks_${item}-error`, "");
          });
          if (!!callback) {
            callback();
            const formAsString = data.split('&').map(el => '"' + el.replaceAll('ProjectsTasks%5B','').replaceAll('%5D','').replaceAll('=', '":"') + '"');
            const formAsObj = JSON.parse('{' + formAsString.join(',') + '}');
            onCreateClickDataLaterPush(formAsObj.price, parseFloat(formAsObj.service_fee_compensation) > 0)
          } else {
            nextTab();
            onNextStepClickDataLaterPush(step);
          }
        } else if (response.response && response.response.errors) {
          const errorFields = Object.keys(response.response.errors);
          let diffWithErrorFields = fields.filter(x => !errorFields.includes(x));
          diffWithErrorFields.forEach((item) => {
            setErrorText(`#ProjectsTasks_${item}-error`, "");
          });

          errorFields.forEach((item) => {
            setErrorText(
              `#ProjectsTasks_${item}-error`,
              response.response.errors[item]
            );
            onNextStepClickDataLaterPush(step, response.response.errors[item]);
          });
          $form.find('button').attr({ disabled: false });
        }
      }
    },
    error() {
      $form.find('button').attr({ disabled: false });
    }
  });
};

const setupEnableSteps = () => {
  const $rootWizard = $("#rootwizard");
  if (
    $rootWizard &&
    ($rootWizard.data("type") === "reuse" ||
      $rootWizard.data("type") === "edit")
  ) {
    $(".wizard .nav li").removeClass("disabled");
  }

  if ($(".error-message").toArray().length) {
    const firstError = $(".error-message")
      .toArray()
      .find((x) => !!x.innerText.replace(/\s/g, ""));
    if (firstError) {
      const currentPane$ = $(firstError).closest(".tab-pane");
      if (currentPane$.length) {
        const paneId = currentPane$.attr("id");
        const $active = $(".wizard .nav li.active");
        $active.removeClass("active");
        $active.next().removeClass("disabled");
        $(`a[href="#${paneId}"]`).click();
      }
    }
  }
};

const goNextEvent = (event, validations, callback) => {
  event.preventDefault();
  if (
    validations
      .map(
        (item) =>
          item.validator(
            item.selector,
            item.errorSelector,
            item.errorMessage,
            item.restriction
          ) === null
      )
      .reduce((result, isValid) => isValid && result)
  ) {
    if (callback) {
      callback();
    } else {
      nextTab();
    }
  } else {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(".error-message:not(:empty):first").offset().top - 150,
      },
      300
    );
  }
};
